module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_vm._v("For my daughter Emily, the fiercest warrior I know. Keep fighting, you’re worth the fight. Learn and grow stronger from every battle, every loss, every victory.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-first"
  }, [_vm._v("    To the memory of Leslie Phillips Barger.")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-first"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-first"
  }, [_vm._v("    “If a thing loves, it is infinite.”")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-first"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-last"
  }, [_vm._v("—William Blake")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0